import React from 'react';
import { Flex, Progress, Text } from '@skin-seoul/design-system';
import type { Currency } from '@skin-seoul/service';
import { CLASSNAME, formatCurrency } from '@skin-seoul/service';
import { Condition } from '@skin-seoul/utils';

type FreeShippingProgressProps = {
  amountToFreeShipping: number;
  currency: Currency;
  isFreeShipping: boolean;
  threshold: number;
};

const FreeShippingProgress = ({
  amountToFreeShipping,
  currency,
  threshold = 0,
  isFreeShipping,
}: FreeShippingProgressProps) => {
  const getRange = () => {
    const range = 100 - (amountToFreeShipping / threshold) * 100;
    if (range > 100 || isFreeShipping) {
      return 100;
    }
    return range;
  };

  return (
    <Flex
      alignItems="center"
      backgroundColor="white"
      border="2px solid"
      borderColor="#a8b3ff4d"
      borderRadius="8px"
      flexDirection="column"
      padding="12px"
      gap={3}
    >
      <Condition
        expression={amountToFreeShipping === 0 || isFreeShipping}
        then={
          <Text textStyle="label.small" whiteSpace="nowrap" className={CLASSNAME.NOT_TRANSLATE}>
            <Text textStyle="label.medium" fontWeight="bold" as="strong">
              Congratulations!
            </Text>{' '}
            You are eligible for{' '}
            <Text textStyle="label.medium" fontWeight="bold" as="strong">
              free shipping.
            </Text>
          </Text>
        }
        else={
          <Text textStyle="label.small" className={CLASSNAME.NOT_TRANSLATE}>
            You&#39;re {formatCurrency(currency, amountToFreeShipping)} away from{' '}
            <Text textStyle="label.small" fontWeight="bold" as="strong">
              free shipping.
            </Text>
          </Text>
        }
      />
      <Progress.Root size="sm" value={getRange()} width="100%" height="10px" variant="legacy">
        <Progress.Track>
          <Progress.Range />
        </Progress.Track>
      </Progress.Root>
    </Flex>
  );
};

export default FreeShippingProgress;
